<app-italo-ecu-logo></app-italo-ecu-logo>
<app-intro-slider></app-intro-slider>
<app-language-switcher></app-language-switcher>
<app-navigation></app-navigation>
